<div
	*ngIf="entity?.id" class="details-wrapper"
	class="theme-{{ theme }}"
	(ngInit)="onEntityInit(entity)"
>
	<h3 *ngIf="!hideHeading">{{ 'DETAILS' | translate }}</h3>

	<div class="line" *ngIf="theme === 'analytics'">
		<label>{{ 'TITLE' | translate }}</label>
		<span class="text-only">{{entity.title}}</span>
	</div>

	<div class="line">
		<label>{{ 'ID' | translate }}</label>
		<code *ngIf="theme !== 'analytics'" class="text-only">{{entity.id}}</code>
		<a class="blue" [routerLink]="['/library/mediaclip/', entity.id]" *ngIf="theme === 'analytics'">
			{{entity.id}}
		</a>
	</div>
	<div class="line" *ngIf="entity.createddate">
		<label>{{ 'CREATED' | translate }}</label>
		<div>
			<p [title]="entity.createddate | bbDate">
				{{ entity.createddate | bbDate:'relative' }}
			</p>
			<small *ngIf="entity?.createdBy"> {{ 'BY' | translate }}
				<a *ngIf="createdByIsEmailAddress" class="blue" [href]="'mailto:' + entity?.createdBy">{{ entity?.createdBy }}</a>
				<span class="black" *ngIf="!createdByIsEmailAddress">{{ entity?.createdBy }}</span>
			</small>
		</div>
	</div>
	<div class="line" *ngIf="entity.updateddate">
		<label>{{ 'MODIFIED' | translate }}</label>
		<div>
			<p [title]="entity.updateddate | bbDate">
					{{ entity.updateddate | bbDate:'relative' }}
			</p>
			<small *ngIf="entity?.updatedBy"> {{ 'BY' | translate }}
				<a *ngIf="updatedByIsEmailAddress" class="blue" [href]="'mailto:' + entity?.updatedBy">{{ entity?.updatedBy }}</a>
				<span class="black" *ngIf="!updatedByIsEmailAddress">{{ entity?.updatedBy }}</span>
			</small>
		</div>
	</div>
	<div class="line" *ngIf="entity.publisheddate">
		<label>{{ 'PUBLISHED' | translate }}</label>
		<div>
			<p [title]="entity.publisheddate | bbDate" >
					{{ entity.publisheddate | bbDate:'relative' }}
			</p>
			<p class="gray" *ngIf="!entity.publisheddate">{{'NOT_YET_PUBLISHED' | translate}}</p>
		</div>
	</div>
	<div class="line" *ngIf="(entity.mediatype === 'video' || entity.mediatype === 'audio') && entity.sourcetype !== 'live'">
		<label>{{ 'LENGTH' | translate }}</label>
		<div>{{ entity.length | seconds }}<small>&nbsp;({{ entity.length | seconds : 'long' }})</small></div>
	</div>
	<div class="line" *ngIf="entity.sourceid && !importedMediaclipUrl">
		<label>{{ 'SOURCE_ID' | translate }}</label>
		<code>{{ entity.sourceid }}</code>
	</div>
	<div class="line" *ngIf="importedMediaclipUrl">
		<label>{{ 'IMPORTED_FROM' | translate }}</label>
		<code class="blue"><a target="_blank" [href]="importedMediaclipUrl">{{ importedMediaclipUrl }}</a></code>
	</div>
	<div class="line" *ngIf="entity.sourcetype !== 'live' && entity.originalfilename">
		<label>{{ 'ORIGINAL_FILE' | translate }}</label>
		<code class="blue"><a target="_blank" [href]="sourceUrl">{{ entity.originalfilename }}</a></code>
	</div>
</div>
